import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/start/')({
  beforeLoad: () => {
    throw redirect({ to: '/', search: true, replace: true });
  },
});
